import React from 'react'

const TransferBranches = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Transfer Branches</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Transfer Warehouses & Branches</li>
            <li className="breadcrumb-item active">Branches</li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="bi bi-shop me-2"></i>
                  Transfer Branches
                </h5>
                <p>Manage stock transfers between branches. Create, track, and monitor branch-to-branch transfers.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default TransferBranches

